module.exports = __webpack_public_path__ + "static/media/site.eda7e3d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/site.svg
// module id = 1547
// module chunks = 0